(function () {
  'use strict';

  angular.module('lif.controllers').controller('registerController', registerController);
  registerController.$inject = ['$scope'];

  function registerController($scope) {
    var vm = this;
    vm.emailAlreadyExists = false;
    vm.isBusy = false;
    var emailSearchDelay = 1000;

    vm.openTacModal = function () {
      $("#tac-modal").modal("show");
    }; //Todo: implement with ng-change instead


    var init = function init() {
      var delay = function () {
        var timer = 0;
        return function (callback, ms) {
          clearTimeout(timer);
          timer = setTimeout(callback, ms);
        };
      }();

      $("#signupemail").on("change", function () {
        vm.isBusy = true;
        $scope.$apply();
        delay(function () {
          $.getJSON("/GetCompanies?email=" + $("#signupemail").val(), function (jsonResult) {
            $("#companylist").empty();
            $("#companylistdisabled").hide();
            $("#companylist").show();
            $("#notconnected").hide();

            if (jsonResult.Companies.length > 1) {
              $("#companylist").append($("<option></option>").text("Välj företag").val(""));
            }

            if (jsonResult.Companies.length === 1) {
              $("#companyid").val(jsonResult.Companies[0].UserName);
            }

            $.each(jsonResult.Companies, function () {
              $("#companylist").append($("<option></option>").text(this.Name).val(this.UserName));
            });
            vm.emailAlreadyExists = jsonResult.EmailAlreadyExists;
            vm.isBusy = false;
            $scope.$apply();
          }).error(function () {
            vm.emailAlreadyExists = false;
            vm.isBusy = false;
            $scope.$apply();
            $("#notconnected").show();
            $("#companyid").val("");
            $("#companylist").empty();
            $("#companylist").hide();
            $("#companylistdisabled").show();
          });
        }, emailSearchDelay);
        $("#companylist").change(function () {
          $("#companyid").val(this.value);
        });
      });
    };

    init();

    $scope.showPasswordsAreNotSameError = function () {
      return $scope.password1 != $scope.password2;
    };
  }
})();